import { Auth } from "aws-amplify";

export async function initUser() {
  let user;
  try {
    user = await Auth.currentUserInfo();
  } catch (error) {
    throw error;
  }

  if (!user?.attributes) {
    const error = new Error("Access Token has been revoked");
    error.name = "NotAuthorizedException";
    throw error;
  }

  let auth;
  try {
    auth = await Auth.currentSession();
  } catch (error) {
    throw error;
  }

  const groups = auth.getAccessToken().payload["cognito:groups"] || [];
  user.attributes.groups = groups;

  return user;
}
